import { Send } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { RecycleJobs } from "@/components/recycle/RecycleJobs";
import { RecycleSend } from "@/components/recycle/RecycleSend";

const CIVILITY = /^(mr|m\.?|mme|mlle|mme\.|monsieur|madame|mademoiselle)$/i;
const firstName = (name) => (name || "").trim().split(/\s+/).find((w) => !CIVILITY.test(w)) || name;

export const FilePrepNocrm = ({ count, buildConfig, file }) => {
  const [meta, setMeta] = useState({ agents: [], tags: [] });
  const [cfg, setCfg] = useState({ title: "Prospection", description: "", tags: [], agents: [] });
  const [jobs, setJobs] = useState([]);
  const [sending, setSending] = useState(false);
  const loadJobs = useCallback(() => api.get("/recycle/jobs").then(({ data }) => setJobs(data.filter((j) => j.source === "file"))).catch(() => {}), []);

  useEffect(() => {
    api.get("/agent-stats/filters").then(({ data }) => setMeta({ agents: data.agents.filter((a) => a.active), tags: data.tags })).catch(() => {});
    loadJobs();
  }, [loadJobs]);
  useEffect(() => {
    if (!jobs.some((j) => j.status === "running")) return undefined;
    const t = setInterval(loadJobs, 3000);
    return () => clearInterval(t);
  }, [jobs, loadJobs]);

  const send = async () => {
    const config = buildConfig();
    if (!config) return;
    setSending(true);
    const body = new FormData();
    body.append("file", file);
    body.append("config", JSON.stringify({
      ...config, title: cfg.title, description: cfg.description, tags: cfg.tags, agents: cfg.agents,
      agent_names: Object.fromEntries(meta.agents.filter((a) => cfg.agents.includes(a.id)).map((a) => [String(a.id), firstName(a.name)])),
    }));
    try {
      const { data } = await api.post("/file-prep/send", body);
      toast.success(`Envoi lancé : ${data.total_lists} liste(s) en cours de création dans noCRM.`);
      loadJobs();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Envoi impossible.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="settings-section" data-testid="file-prep-nocrm">
      <div className="section-title">
        <Send size={20} />
        <div><p className="eyebrow">ENVOI NOCRM</p><h2>Répartir entre les commerciaux et envoyer dans noCRM</h2></div>
      </div>
      <p className="fileprep-dedup-hint">Coche les commerciaux à servir : le fichier est mélangé au hasard puis découpé en parts égales. Chaque commercial reçoit sa propre liste de prospection noCRM, nommée avec son prénom.</p>
      <RecycleSend agents={meta.agents} tagOptions={meta.tags} count={count} lists={Math.max(1, Math.ceil(count / 4999))} sending={sending} onSend={send} cfg={cfg} setCfg={setCfg} recycledNote={false} />
      {jobs.length > 0 && <div style={{ marginTop: 16 }}><RecycleJobs jobs={jobs} /></div>}
    </section>
  );
};
